import { complaintType } from '../choices'
import { FileUploader } from '../components/FileUploader'

export const complaintTypeField = {
  type: 'radio',
  choices: [{ label: '', value: '' }, ...complaintType()],
  name: 'complaint_type',
  label: 'Complaint type'
}

export const multilineField = {
  type: 'text',
  name: 'multiline',
  label: 'Textarea',
  maxLength: 2000,
  displayCharsRemaining: true,
  multiline: true,
  rows: 8
}

export const fileField = {
  name: 'documents',
  type: 'file',
  label: 'Documents',
  component: FileUploader
}
